import React from "react";
import { EuiBasicTable } from "@elastic/eui";
import Content from "components/Content";

import { useSelector } from "react-redux";
import { useAddQueryNavigation } from "helpers/hooks/url";

const List = () => {
  const propertyTemplates = useSelector(
    state => state.property_templates.items
  );

  const addQuery = useAddQueryNavigation();

  const actions = [
    {
      name: "Löschen",
      description: "Dieses Datenformat löschen",
      icon: "trash",
      color: "danger",
      type: "icon",
      onClick: e => {
        addQuery("deletePropertyTemplate", e.id);
      }
    },
    {
      name: "Edit",
      isPrimary: true,
      description: "Dieses Datenformat bearbeiten",
      icon: "pencil",
      type: "icon",

      onClick: e => {
        addQuery("editPropertyTemplate", e.id);
      }
    }
  ];

  const columns = [
    { field: "id", name: "#" },
    { field: "name", name: "Name" },
    { field: "description", name: "Beschreibung" },
    { field: "updated_at", name: "Letztes Update", dataType: "date" },
    { field: "created_at", name: "Erstellt am", dataType: "date" },
    { name: "Aktionen", actions }
  ];

  return (
    <Content title="Übersicht">
      <EuiBasicTable
        items={Object.values(propertyTemplates)}
        columns={columns}
      />
    </Content>
  );
};

export default List;
